import { FirmConfigApi, type FirmFeaturesVO } from '@/api/lawyer/firmConfig'
import { isFirmModuleEnabled, normalizeFirmModules } from '@/utils/firmModules'
import { canCallLawyerMenuApis } from '@/utils/bizModeMenus'
import { CACHE_KEY, useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()

const firmModulesState = ref<Record<string, boolean>>(normalizeFirmModules(null))
const firmErpEnabledState = ref(true)
const loaded = ref(false)

export function useFirmModules() {
  const loadFirmModules = async (force = false) => {
    if (loaded.value && !force) {
      return firmModulesState.value
    }
    // 未开通律师：勿打 /lawyer/firm/config/features，与 tenant-config/get 同源噪音
    if (!canCallLawyerMenuApis()) {
      firmErpEnabledState.value = false
      firmModulesState.value = normalizeFirmModules(null)
      loaded.value = true
      return firmModulesState.value
    }
    try {
      const data: FirmFeaturesVO = await FirmConfigApi.features()
      firmErpEnabledState.value = data.firmErpEnabled !== false
      firmModulesState.value = normalizeFirmModules(data.firmModules)
      wsCache.set(CACHE_KEY.FIRM_FEATURES, data)
    } catch {
      const cached = wsCache.get(CACHE_KEY.FIRM_FEATURES) as FirmFeaturesVO | undefined
      if (cached) {
        firmErpEnabledState.value = cached.firmErpEnabled !== false
        firmModulesState.value = normalizeFirmModules(cached.firmModules)
      }
    } finally {
      loaded.value = true
    }
    return firmModulesState.value
  }

  const isModuleEnabled = (moduleKey: string) =>
    isFirmModuleEnabled(firmModulesState.value, moduleKey)

  return {
    firmModules: firmModulesState,
    firmErpEnabled: firmErpEnabledState,
    loaded,
    loadFirmModules,
    isModuleEnabled
  }
}

export async function loadFirmModulesForMenu(): Promise<Record<string, boolean>> {
  const { loadFirmModules } = useFirmModules()
  return loadFirmModules()
}
